import React from "react";
import Text from "../atoms/Text";
import Icon from "../atoms/Icon";
export default function FeedbackCard({
  userIcon,
  userName,
  feedbackText,
  compact = false,
}) {
  const wrapperWidth = compact ? "100%" : "424px";
  const cardWidth = compact ? "100%" : "424px";
  const cardHeight = compact ? "210px" : "240px";
  const cardPadding = compact ? "24px" : "32px";
  const cardGap = compact ? "18px" : "24px";
  const textWidth = compact ? "100%" : "360px";
  const textColor = compact ? "greenG9" : "greenG6";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "28px",
        width: wrapperWidth,
      }}
    >
      <div
        className="feedbackCard"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: cardGap,
          padding: cardPadding,
          borderRadius: "10px",
          position: "relative",
          backgroundColor: "var(--white)",
          alignItems: "center",
          width: cardWidth,
          boxSizing: "border-box",
          height: cardHeight,
          border: compact ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
          boxShadow: compact ? "0 20px 40px rgba(0, 0, 0, 0.12)" : "none",
        }}
      >
        <Icon
          src={require("../../assets/feedbackVector.png")}
          style={{ display: "block", width: "40px", height: "32px," }}
        />
        <Text
          size="px16"
          weight="w400"
          color={textColor}
          extraStyles={{
            lineHeight: "150%",
            width: textWidth,
            textAlign: "center",
          }}
        >
          {feedbackText}
        </Text>
        <span
          style={{
            width: "17px",
            height: "17px",
            backgroundColor: "var(--white)",
            transform: "rotate(45deg)",
            position: "absolute",
            bottom: "-8px",
          }}
        ></span>
      </div>
      <div
        className="userInfo"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: wrapperWidth,
        }}
      >
        <Icon
          src={userIcon}
          style={{ width: "64px", height: "64px" }}/>
        <Text size="px16" weight="w500" color="greenG9" extraStyles={{ margin: "14px 0px 0px", lineHeight: "150%" }}>
          {userName}
        </Text>
        <Text size="px14" weight="w400" color="greenG5" extraStyles={{ lineHeight: "150%", marginTop: "0px !important" }}>
          Customer
        </Text>
      </div>
    </div>
  );
}
